import { StylesConfig } from 'react-select';
import { SelectOption } from '../MultiFilterDropdown';
import { ItemList } from 'v2/models';

export function getSelectStyles<T>(currentState: ItemList) {
  const selectStyles: StylesConfig<SelectOption<T>, boolean> = {
    container: () => ({
      width: '100%',
      backgroundColor: '#F8FAFF',
      border: '1px solid #d0d0d057',
      borderRadius: '5px 5px 0px 0px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
      position: 'absolute',
    }),
    control: () => ({
      background: '#FFFFFF',
      border: '1.5px solid #DDE5F7',
      borderRadius: '50px',
      margin: '10px',
      display: 'flex',
      cursor: currentState.is_all ? 'not-allowed' : 'text',
      height: '50px',
      paddingRight: '20px',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 50000 }),
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
      boxSizing: 'border-box',
      borderRadius: '5px 5px 0px 0px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
    }),
    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      boxSizing: 'border-box',
      maxHeight: '240px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#285FCB',
      ':hover': {
        color: '#285FCB',
      },
      position: 'absolute',
      left: '630px',
      bottom: '5px',
      cursor: 'pointer',
    }),
    placeholder: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? base.color : '#666666',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      alignSelf: 'center',
    }),
    input: (provided) => ({
      ...provided,
      input: {
        opacity: '1 !important',
      },
    }),
  };

  return selectStyles;
}

export function getMultiSelectStyles<T>() {
  const selectStylesMulti: StylesConfig<SelectOption<T>, true> = {
    option: (provided) => ({
      ...provided,
      backgroundColor: '#285FCB12',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#285FCB12',
      alignItems: 'center',
      fontWeight: 500,
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      alignItems: 'center',
      borderRadius: '2px',
      display: 'flex',
      paddingLeft: '4px',
      paddingRight: '4px',
      boxSizing: 'border-box',
      height: 22,
      width: 22,
      ':hover': {
        backgroundColor: '#8194bb',
        color: 'white',
      },
    }),
    control: (provided) => ({
      display: 'flex',
      maxWidth: '679px',
      minHeight: '52px',
      border: '1px solid transparent',
      borderRadius: '5px',
      borderColor: '#CED4DA',
      paddingLeft: 4,
      backgroundColor: provided.backgroundColor,
      cursor: 'pointer',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#285FCB',
      ':hover': {
        color: '#285FCB',
      },
      svg: {
        boxSizing: 'unset',
      },
      right: '10px',
      justifyContent: 'flex-end',
    }),
    placeholder: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? base.color : '#666666',
    }),
    valueContainer: (base) => ({
      ...base,
      flexWrap: 'nowrap',
    }),
  };
  return selectStylesMulti;
}
